// Sliders initialization - variables already set by modal-master-clean-v2.js
console.log('Theme scripts loaded');
